/** Textes de la zone Facturation (FR / EN / AR) : fusionnés dans les dictionnaires de `i18n/locales`. */

export const billingFr = {
  'billing.pageTitle': 'Abonnement et facturation',
  'billing.pageDesc': 'Plan, utilisation, factures et moyens de paiement de l\'organisation.',
  'billing.tabs': 'Sections de la facturation',
  'billing.tab.overview': 'Vue d\'ensemble',
  'billing.tab.plans': 'Plans',
  'billing.tab.invoices': 'Factures',
  'billing.tab.payment': 'Paiement',
  'billing.cancel': 'Annuler',
  'billing.yes': 'Inclus',
  'billing.no': 'Non inclus',
  'billing.unlimitedShort': 'Illimité',
  'billing.currency.label': 'Devise d\'affichage',
  'billing.currency.dzd': 'Dinar algérien (DA)',
  'billing.currency.eur': 'Euro (EUR)',
  'billing.currency.da': 'DA',
  'billing.plan.free': 'Gratuit',
  'billing.plan.pro': 'Pro',
  'billing.plan.team': 'Équipe',
  'billing.plan.enterprise': 'Entreprise',
  'billing.plan.current': 'Plan actuel',
  'billing.plan.currentBadge': 'Plan actuel',
  'billing.plan.estimate': 'Estimation mensuelle',
  'billing.plan.perMonth': '{amount} / mois',
  'billing.plan.custom': 'Sur devis',
  'billing.plan.renews': 'Prochain renouvellement',
  'billing.plan.trialEnds': 'Fin de l\'essai',
  'billing.plan.includes': 'Inclus',
  'billing.plan.includesValue': '{techs} technicien(s) · {devices} appareil(s)',
  'billing.plan.change': 'Changer de plan',
  'billing.status.trialing': 'Essai gratuit',
  'billing.status.active': 'Actif',
  'billing.status.past_due': 'Impayé',
  'billing.status.suspended': 'Suspendu',
  'billing.status.canceled': 'Résilié',
  'billing.lifecycle.title': 'Cycle de l\'abonnement',
  'billing.lifecycle.desc': 'Essai, actif, impayé puis suspendu : le service est rétabli dès le paiement régularisé.',
  'billing.banner.trialTitle': 'Essai gratuit : {count} jour(s) restant(s)',
  'billing.banner.trialDesc': 'L\'essai se termine le {date}. Choisissez un plan pour continuer sans interruption.',
  'billing.banner.choosePlan': 'Choisir un plan',
  'billing.banner.pastDueTitle': 'Paiement en échec',
  'billing.banner.pastDueDesc': 'Le service sera suspendu dans {days} jour(s) (le {date}) si le paiement n\'est pas régularisé.',
  'billing.banner.suspendedTitle': 'Compte suspendu',
  'billing.banner.suspendedDesc': 'Les connexions sont bloquées et la console est en lecture seule. Régularisez le paiement pour rétablir le service.',
  'billing.banner.updateMethod': 'Moyen de paiement',
  'billing.banner.payNow': 'Régler maintenant',
  'billing.banner.paid': 'Paiement réussi, service rétabli',
  'billing.banner.payFailed': 'Le paiement a échoué',
  'billing.banner.needMethod': 'Ajoutez d\'abord un moyen de paiement',
  'billing.mode.title': 'Mode de facturation',
  'billing.mode.desc': 'Facturez au nombre de techniciens ou au nombre d\'appareils gérés.',
  'billing.mode.per_technician': 'Par technicien',
  'billing.mode.per_device': 'Par appareil',
  'billing.mode.saved': 'Mode de facturation mis à jour',
  'billing.mode.error': 'Changement impossible',
  'billing.mode.freeNote': 'Le plan Gratuit n\'est pas facturé.',
  'billing.usage.title': 'Utilisation et quotas',
  'billing.usage.desc': 'Consommation actuelle par rapport aux limites de votre plan.',
  'billing.usage.technicians': 'Techniciens',
  'billing.usage.devices': 'Appareils',
  'billing.usage.aiCredits': 'Crédits IA',
  'billing.usage.of': '{used} / {limit} ({pct} %)',
  'billing.usage.unlimited': '{used} · illimité',
  'billing.usage.near': 'Proche de la limite',
  'billing.usage.reached': 'Limite atteinte',
  'billing.usage.aiDetail': '{used} / {allowance} crédits ce mois-ci, plus {purchased} achetés. Reste {remaining}. Renouvellement le {renews}.',
  'billing.usage.aiNear': '{pct} % de l\'allocation de crédits IA du mois consommés.',
  'billing.usage.aiAllowanceOut': 'Allocation du mois épuisée : {purchased} crédits achetés restants.',
  'billing.usage.aiExhausted': 'Plus aucun crédit IA : achetez des crédits pour continuer à utiliser l\'assistant.',
  'billing.cmp.title': 'Comparatif des plans',
  'billing.cmp.desc': 'Prix indicatifs hors taxes, par technicien et par mois.',
  'billing.cmp.feature': 'Fonctionnalité',
  'billing.cmp.perTechnician': 'Prix par technicien',
  'billing.cmp.perDevice': 'Prix par appareil',
  'billing.cmp.creditsPerMonth': 'Crédits IA / mois',
  'billing.cmp.retention': 'Conservation de l\'audit',
  'billing.cmp.days': '{count} jours',
  'billing.cmp.sso': 'SSO et SCIM',
  'billing.cmp.recordings': 'Enregistrement des sessions',
  'billing.cmp.whiteLabel': 'Marque blanche',
  'billing.cmp.support': 'Support',
  'billing.support.community': 'Communauté',
  'billing.support.email': 'E-mail',
  'billing.support.priority': 'Prioritaire',
  'billing.support.dedicated': 'Dédié',
  'billing.seats.label': 'Nombre de techniciens',
  'billing.seats.hint': 'De 1 à 25 techniciens, facturés par technicien et par mois.',
  'billing.seats.range': '1 à 25',
  'billing.change.cta': 'Choisir',
  'billing.change.choose': 'Choisir le plan {plan}',
  'billing.change.title': 'Confirmer le changement de plan',
  'billing.change.desc': 'Passer du plan {from} au plan {to}.',
  'billing.change.note': 'Le nouveau tarif s\'applique immédiatement, au prorata de la période en cours.',
  'billing.change.exceeded': 'Votre consommation dépasse les limites de ce plan : {resources}. Réduisez-la avant de changer.',
  'billing.change.confirm': 'Confirmer',
  'billing.change.done': 'Plan {plan} activé',
  'billing.change.error': 'Changement de plan impossible',
  'billing.inv.title': 'Factures',
  'billing.inv.desc': 'Historique des factures et état des paiements.',
  'billing.inv.number': 'Numéro',
  'billing.inv.date': 'Date',
  'billing.inv.amount': 'Montant',
  'billing.inv.provider': 'Prestataire',
  'billing.inv.status': 'Statut',
  'billing.inv.status.paid': 'Payée',
  'billing.inv.status.open': 'À payer',
  'billing.inv.status.failed': 'Échec',
  'billing.inv.status.refunded': 'Remboursée',
  'billing.inv.download': 'Télécharger',
  'billing.inv.downloadOf': 'Télécharger la facture {number} (PDF)',
  'billing.inv.downloaded': 'Facture {number} téléchargée',
  'billing.inv.empty': 'Aucune facture',
  'billing.provider.satim': 'SATIM / CIB',
  'billing.provider.stripe': 'Stripe',
  'billing.brand.cib': 'Carte CIB',
  'billing.brand.visa': 'Visa',
  'billing.brand.mastercard': 'Mastercard',
  'billing.pay.title': 'Moyens de paiement',
  'billing.pay.desc': 'Paiement local par SATIM/CIB ou international par Stripe.',
  'billing.pay.add': 'Ajouter un moyen de paiement',
  'billing.pay.addDesc': 'Vous saisissez votre carte chez le prestataire ; Siraj ne conserve qu\'un jeton.',
  'billing.pay.addConfirm': 'Continuer vers le prestataire',
  'billing.pay.added': 'Moyen de paiement ajouté',
  'billing.pay.provider': 'Prestataire',
  'billing.pay.brand': 'Type de carte',
  'billing.pay.hostedNote': 'Simulation du formulaire sécurisé du prestataire : le numéro complet n\'est jamais demandé ici.',
  'billing.pay.last4': '4 derniers chiffres',
  'billing.pay.last4Invalid': 'Entrez exactement 4 chiffres',
  'billing.pay.expiry': 'Expiration (MM/AA)',
  'billing.pay.expiryInvalid': 'Format attendu : MM/AA',
  'billing.pay.expires': 'Expire le {date}',
  'billing.pay.default': 'Par défaut',
  'billing.pay.makeDefault': 'Définir {name} par défaut',
  'billing.pay.remove': 'Supprimer {name}',
  'billing.pay.removeTitle': 'Supprimer ce moyen de paiement ?',
  'billing.pay.removeDesc': 'Le jeton sera révoqué chez le prestataire.',
  'billing.pay.removeConfirm': 'Supprimer',
  'billing.pay.removed': 'Moyen de paiement supprimé',
  'billing.pay.removeError': 'Suppression impossible',
  'billing.pay.removeDefault': 'Définissez d\'abord un autre moyen par défaut',
  'billing.pay.error': 'Opération impossible',
  'billing.pay.empty': 'Aucun moyen de paiement',
  'billing.pay.emptyDesc': 'Ajoutez une carte CIB ou une carte internationale.',
  'billing.pay.tokenNote': 'Aucun numéro de carte n\'est stocké par Siraj : seuls un jeton, la marque, les 4 derniers chiffres et l\'expiration sont conservés.',
  'billing.credits.buy': 'Acheter des crédits IA',
  'billing.credits.title': 'Acheter des crédits IA',
  'billing.credits.desc': 'Les crédits s\'ajoutent immédiatement à votre quota.',
  'billing.credits.pack': '{count} crédits',
  'billing.credits.confirm': 'Payer {amount}',
  'billing.credits.done': '{count} crédits ajoutés',
  'billing.credits.error': 'Achat impossible',
  'billing.credits.needMethod': 'Un moyen de paiement est nécessaire pour acheter des crédits.',
  'billing.credits.addMethod': 'Ajouter un moyen de paiement',
} as const;

export const billingEn: Record<keyof typeof billingFr, string> = {
  'billing.pageTitle': 'Subscription and billing',
  'billing.pageDesc': 'Your organization\'s plan, usage, invoices and payment methods.',
  'billing.tabs': 'Billing sections',
  'billing.tab.overview': 'Overview',
  'billing.tab.plans': 'Plans',
  'billing.tab.invoices': 'Invoices',
  'billing.tab.payment': 'Payment',
  'billing.cancel': 'Cancel',
  'billing.yes': 'Included',
  'billing.no': 'Not included',
  'billing.unlimitedShort': 'Unlimited',
  'billing.currency.label': 'Display currency',
  'billing.currency.dzd': 'Algerian dinar (DA)',
  'billing.currency.eur': 'Euro (EUR)',
  'billing.currency.da': 'DA',
  'billing.plan.free': 'Free',
  'billing.plan.pro': 'Pro',
  'billing.plan.team': 'Team',
  'billing.plan.enterprise': 'Enterprise',
  'billing.plan.current': 'Current plan',
  'billing.plan.currentBadge': 'Current plan',
  'billing.plan.estimate': 'Monthly estimate',
  'billing.plan.perMonth': '{amount} / month',
  'billing.plan.custom': 'Custom quote',
  'billing.plan.renews': 'Next renewal',
  'billing.plan.trialEnds': 'Trial ends',
  'billing.plan.includes': 'Includes',
  'billing.plan.includesValue': '{techs} technician(s) · {devices} device(s)',
  'billing.plan.change': 'Change plan',
  'billing.status.trialing': 'Free trial',
  'billing.status.active': 'Active',
  'billing.status.past_due': 'Past due',
  'billing.status.suspended': 'Suspended',
  'billing.status.canceled': 'Canceled',
  'billing.lifecycle.title': 'Subscription lifecycle',
  'billing.lifecycle.desc': 'Trial, active, past due then suspended: service resumes as soon as payment is settled.',
  'billing.banner.trialTitle': 'Free trial: {count} day(s) left',
  'billing.banner.trialDesc': 'The trial ends on {date}. Choose a plan to continue without interruption.',
  'billing.banner.choosePlan': 'Choose a plan',
  'billing.banner.pastDueTitle': 'Payment failed',
  'billing.banner.pastDueDesc': 'Service will be suspended in {days} day(s) ({date}) unless payment is settled.',
  'billing.banner.suspendedTitle': 'Account suspended',
  'billing.banner.suspendedDesc': 'Connections are blocked and the console is read-only. Settle the payment to restore service.',
  'billing.banner.updateMethod': 'Payment method',
  'billing.banner.payNow': 'Pay now',
  'billing.banner.paid': 'Payment successful, service restored',
  'billing.banner.payFailed': 'Payment failed',
  'billing.banner.needMethod': 'Add a payment method first',
  'billing.mode.title': 'Billing mode',
  'billing.mode.desc': 'Bill by number of technicians or by number of managed devices.',
  'billing.mode.per_technician': 'Per technician',
  'billing.mode.per_device': 'Per device',
  'billing.mode.saved': 'Billing mode updated',
  'billing.mode.error': 'Could not change the mode',
  'billing.mode.freeNote': 'The Free plan is not billed.',
  'billing.usage.title': 'Usage and quotas',
  'billing.usage.desc': 'Current consumption against your plan limits.',
  'billing.usage.technicians': 'Technicians',
  'billing.usage.devices': 'Devices',
  'billing.usage.aiCredits': 'AI credits',
  'billing.usage.of': '{used} / {limit} ({pct}%)',
  'billing.usage.unlimited': '{used} · unlimited',
  'billing.usage.near': 'Close to the limit',
  'billing.usage.reached': 'Limit reached',
  'billing.usage.aiDetail': '{used} / {allowance} credits this month, plus {purchased} purchased. {remaining} left. Renews on {renews}.',
  'billing.usage.aiNear': '{pct}% of this month\'s AI credit allowance used.',
  'billing.usage.aiAllowanceOut': 'This month\'s allowance is used up: {purchased} purchased credits left.',
  'billing.usage.aiExhausted': 'No AI credits left: buy credits to keep using the assistant.',
  'billing.cmp.title': 'Plan comparison',
  'billing.cmp.desc': 'Indicative prices excluding tax, per technician and per month.',
  'billing.cmp.feature': 'Feature',
  'billing.cmp.perTechnician': 'Price per technician',
  'billing.cmp.perDevice': 'Price per device',
  'billing.cmp.creditsPerMonth': 'AI credits / month',
  'billing.cmp.retention': 'Audit retention',
  'billing.cmp.days': '{count} days',
  'billing.cmp.sso': 'SSO and SCIM',
  'billing.cmp.recordings': 'Session recording',
  'billing.cmp.whiteLabel': 'White label',
  'billing.cmp.support': 'Support',
  'billing.support.community': 'Community',
  'billing.support.email': 'Email',
  'billing.support.priority': 'Priority',
  'billing.support.dedicated': 'Dedicated',
  'billing.seats.label': 'Number of technicians',
  'billing.seats.hint': 'From 1 to 25 technicians, billed per technician and per month.',
  'billing.seats.range': '1 to 25',
  'billing.change.cta': 'Choose',
  'billing.change.choose': 'Choose the {plan} plan',
  'billing.change.title': 'Confirm the plan change',
  'billing.change.desc': 'Switch from the {from} plan to the {to} plan.',
  'billing.change.note': 'The new rate applies immediately, prorated for the current period.',
  'billing.change.exceeded': 'Your usage exceeds this plan\'s limits: {resources}. Reduce it before switching.',
  'billing.change.confirm': 'Confirm',
  'billing.change.done': '{plan} plan activated',
  'billing.change.error': 'Could not change plan',
  'billing.inv.title': 'Invoices',
  'billing.inv.desc': 'Invoice history and payment status.',
  'billing.inv.number': 'Number',
  'billing.inv.date': 'Date',
  'billing.inv.amount': 'Amount',
  'billing.inv.provider': 'Provider',
  'billing.inv.status': 'Status',
  'billing.inv.status.paid': 'Paid',
  'billing.inv.status.open': 'Open',
  'billing.inv.status.failed': 'Failed',
  'billing.inv.status.refunded': 'Refunded',
  'billing.inv.download': 'Download',
  'billing.inv.downloadOf': 'Download invoice {number} (PDF)',
  'billing.inv.downloaded': 'Invoice {number} downloaded',
  'billing.inv.empty': 'No invoices',
  'billing.provider.satim': 'SATIM / CIB',
  'billing.provider.stripe': 'Stripe',
  'billing.brand.cib': 'CIB card',
  'billing.brand.visa': 'Visa',
  'billing.brand.mastercard': 'Mastercard',
  'billing.pay.title': 'Payment methods',
  'billing.pay.desc': 'Local payment through SATIM/CIB or international through Stripe.',
  'billing.pay.add': 'Add a payment method',
  'billing.pay.addDesc': 'You enter your card with the provider; Siraj only keeps a token.',
  'billing.pay.addConfirm': 'Continue to the provider',
  'billing.pay.added': 'Payment method added',
  'billing.pay.provider': 'Provider',
  'billing.pay.brand': 'Card type',
  'billing.pay.hostedNote': 'Simulation of the provider\'s secure form: the full number is never requested here.',
  'billing.pay.last4': 'Last 4 digits',
  'billing.pay.last4Invalid': 'Enter exactly 4 digits',
  'billing.pay.expiry': 'Expiry (MM/YY)',
  'billing.pay.expiryInvalid': 'Expected format: MM/YY',
  'billing.pay.expires': 'Expires {date}',
  'billing.pay.default': 'Default',
  'billing.pay.makeDefault': 'Make {name} the default',
  'billing.pay.remove': 'Remove {name}',
  'billing.pay.removeTitle': 'Remove this payment method?',
  'billing.pay.removeDesc': 'The token will be revoked at the provider.',
  'billing.pay.removeConfirm': 'Remove',
  'billing.pay.removed': 'Payment method removed',
  'billing.pay.removeError': 'Could not remove',
  'billing.pay.removeDefault': 'Set another default method first',
  'billing.pay.error': 'Operation failed',
  'billing.pay.empty': 'No payment method',
  'billing.pay.emptyDesc': 'Add a CIB card or an international card.',
  'billing.pay.tokenNote': 'Siraj never stores card numbers: only a token, the brand, the last 4 digits and the expiry are kept.',
  'billing.credits.buy': 'Buy AI credits',
  'billing.credits.title': 'Buy AI credits',
  'billing.credits.desc': 'Credits are added to your quota immediately.',
  'billing.credits.pack': '{count} credits',
  'billing.credits.confirm': 'Pay {amount}',
  'billing.credits.done': '{count} credits added',
  'billing.credits.error': 'Purchase failed',
  'billing.credits.needMethod': 'A payment method is required to buy credits.',
  'billing.credits.addMethod': 'Add a payment method',
};

export const billingAr: Record<keyof typeof billingFr, string> = {
  'billing.pageTitle': 'الاشتراك والفوترة',
  'billing.pageDesc': 'خطة المؤسسة واستهلاكها وفواتيرها ووسائل الدفع.',
  'billing.tabs': 'أقسام الفوترة',
  'billing.tab.overview': 'نظرة عامة',
  'billing.tab.plans': 'الخطط',
  'billing.tab.invoices': 'الفواتير',
  'billing.tab.payment': 'الدفع',
  'billing.cancel': 'إلغاء',
  'billing.yes': 'مشمول',
  'billing.no': 'غير مشمول',
  'billing.unlimitedShort': 'غير محدود',
  'billing.currency.label': 'عملة العرض',
  'billing.currency.dzd': 'دينار جزائري (DA)',
  'billing.currency.eur': 'يورو (EUR)',
  'billing.currency.da': 'د.ج',
  'billing.plan.free': 'مجاني',
  'billing.plan.pro': 'احترافي',
  'billing.plan.team': 'فريق',
  'billing.plan.enterprise': 'مؤسسات',
  'billing.plan.current': 'الخطة الحالية',
  'billing.plan.currentBadge': 'الخطة الحالية',
  'billing.plan.estimate': 'التقدير الشهري',
  'billing.plan.perMonth': '{amount} / شهريًا',
  'billing.plan.custom': 'حسب العرض',
  'billing.plan.renews': 'التجديد القادم',
  'billing.plan.trialEnds': 'نهاية الفترة التجريبية',
  'billing.plan.includes': 'يشمل',
  'billing.plan.includesValue': '{techs} فني · {devices} جهاز',
  'billing.plan.change': 'تغيير الخطة',
  'billing.status.trialing': 'فترة تجريبية',
  'billing.status.active': 'نشط',
  'billing.status.past_due': 'متأخر السداد',
  'billing.status.suspended': 'معلّق',
  'billing.status.canceled': 'ملغى',
  'billing.lifecycle.title': 'دورة الاشتراك',
  'billing.lifecycle.desc': 'تجريبي، نشط، متأخر ثم معلّق: تعود الخدمة فور تسوية الدفع.',
  'billing.banner.trialTitle': 'فترة تجريبية: متبقٍ {count} يوم',
  'billing.banner.trialDesc': 'تنتهي الفترة التجريبية في {date}. اختر خطة للمتابعة دون انقطاع.',
  'billing.banner.choosePlan': 'اختر خطة',
  'billing.banner.pastDueTitle': 'فشل الدفع',
  'billing.banner.pastDueDesc': 'ستُعلّق الخدمة بعد {days} يوم ({date}) ما لم يُسدَّد المبلغ.',
  'billing.banner.suspendedTitle': 'الحساب معلّق',
  'billing.banner.suspendedDesc': 'الاتصالات محظورة ولوحة التحكم للقراءة فقط. سدّد المبلغ لاستعادة الخدمة.',
  'billing.banner.updateMethod': 'وسيلة الدفع',
  'billing.banner.payNow': 'ادفع الآن',
  'billing.banner.paid': 'تم الدفع واستُعيدت الخدمة',
  'billing.banner.payFailed': 'فشل الدفع',
  'billing.banner.needMethod': 'أضف وسيلة دفع أولًا',
  'billing.mode.title': 'نمط الفوترة',
  'billing.mode.desc': 'الفوترة بعدد الفنيين أو بعدد الأجهزة المُدارة.',
  'billing.mode.per_technician': 'لكل فني',
  'billing.mode.per_device': 'لكل جهاز',
  'billing.mode.saved': 'تم تحديث نمط الفوترة',
  'billing.mode.error': 'تعذّر تغيير النمط',
  'billing.mode.freeNote': 'الخطة المجانية غير مدفوعة.',
  'billing.usage.title': 'الاستخدام والحصص',
  'billing.usage.desc': 'الاستهلاك الحالي مقارنة بحدود خطتك.',
  'billing.usage.technicians': 'الفنيون',
  'billing.usage.devices': 'الأجهزة',
  'billing.usage.aiCredits': 'رصيد الذكاء الاصطناعي',
  'billing.usage.of': '{used} / {limit} ({pct}٪)',
  'billing.usage.unlimited': '{used} · غير محدود',
  'billing.usage.near': 'قريب من الحد',
  'billing.usage.reached': 'تم بلوغ الحد',
  'billing.usage.aiDetail': '{used} / {allowance} رصيد هذا الشهر، إضافة إلى {purchased} مشترى. المتبقي {remaining}. التجديد في {renews}.',
  'billing.usage.aiNear': 'تم استهلاك {pct}٪ من رصيد الذكاء الاصطناعي لهذا الشهر.',
  'billing.usage.aiAllowanceOut': 'نفد رصيد هذا الشهر: يتبقى {purchased} من الرصيد المشترى.',
  'billing.usage.aiExhausted': 'لم يتبقَّ أي رصيد للذكاء الاصطناعي: اشترِ رصيدًا لمواصلة استخدام المساعد.',
  'billing.cmp.title': 'مقارنة الخطط',
  'billing.cmp.desc': 'أسعار استرشادية دون ضرائب، لكل فني وشهريًا.',
  'billing.cmp.feature': 'الميزة',
  'billing.cmp.perTechnician': 'السعر لكل فني',
  'billing.cmp.perDevice': 'السعر لكل جهاز',
  'billing.cmp.creditsPerMonth': 'رصيد الذكاء الاصطناعي / شهر',
  'billing.cmp.retention': 'مدة حفظ سجل التدقيق',
  'billing.cmp.days': '{count} يومًا',
  'billing.cmp.sso': 'الدخول الموحّد وSCIM',
  'billing.cmp.recordings': 'تسجيل الجلسات',
  'billing.cmp.whiteLabel': 'العلامة البيضاء',
  'billing.cmp.support': 'الدعم',
  'billing.support.community': 'المجتمع',
  'billing.support.email': 'البريد الإلكتروني',
  'billing.support.priority': 'ذو أولوية',
  'billing.support.dedicated': 'مخصّص',
  'billing.seats.label': 'عدد الفنيين',
  'billing.seats.hint': 'من 1 إلى 25 فنيًا، بالفوترة لكل فني وشهريًا.',
  'billing.seats.range': 'من 1 إلى 25',
  'billing.change.cta': 'اختيار',
  'billing.change.choose': 'اختيار خطة {plan}',
  'billing.change.title': 'تأكيد تغيير الخطة',
  'billing.change.desc': 'الانتقال من خطة {from} إلى خطة {to}.',
  'billing.change.note': 'يسري السعر الجديد فورًا بنسبة تناسبية للفترة الحالية.',
  'billing.change.exceeded': 'استهلاكك يتجاوز حدود هذه الخطة: {resources}. قلّله قبل التغيير.',
  'billing.change.confirm': 'تأكيد',
  'billing.change.done': 'تم تفعيل خطة {plan}',
  'billing.change.error': 'تعذّر تغيير الخطة',
  'billing.inv.title': 'الفواتير',
  'billing.inv.desc': 'سجل الفواتير وحالة الدفع.',
  'billing.inv.number': 'الرقم',
  'billing.inv.date': 'التاريخ',
  'billing.inv.amount': 'المبلغ',
  'billing.inv.provider': 'المزوّد',
  'billing.inv.status': 'الحالة',
  'billing.inv.status.paid': 'مدفوعة',
  'billing.inv.status.open': 'مستحقة',
  'billing.inv.status.failed': 'فاشلة',
  'billing.inv.status.refunded': 'مستردّة',
  'billing.inv.download': 'تنزيل',
  'billing.inv.downloadOf': 'تنزيل الفاتورة {number} (PDF)',
  'billing.inv.downloaded': 'تم تنزيل الفاتورة {number}',
  'billing.inv.empty': 'لا توجد فواتير',
  'billing.provider.satim': 'ساتيم / CIB',
  'billing.provider.stripe': 'Stripe',
  'billing.brand.cib': 'بطاقة CIB',
  'billing.brand.visa': 'فيزا',
  'billing.brand.mastercard': 'ماستركارد',
  'billing.pay.title': 'وسائل الدفع',
  'billing.pay.desc': 'دفع محلي عبر ساتيم/CIB أو دولي عبر Stripe.',
  'billing.pay.add': 'إضافة وسيلة دفع',
  'billing.pay.addDesc': 'تُدخل بطاقتك لدى المزوّد؛ ويحتفظ سراج برمز فقط.',
  'billing.pay.addConfirm': 'المتابعة إلى المزوّد',
  'billing.pay.added': 'تمت إضافة وسيلة الدفع',
  'billing.pay.provider': 'المزوّد',
  'billing.pay.brand': 'نوع البطاقة',
  'billing.pay.hostedNote': 'محاكاة لنموذج المزوّد الآمن: لا يُطلب الرقم الكامل هنا أبدًا.',
  'billing.pay.last4': 'آخر 4 أرقام',
  'billing.pay.last4Invalid': 'أدخل 4 أرقام بالضبط',
  'billing.pay.expiry': 'الانتهاء (شهر/سنة)',
  'billing.pay.expiryInvalid': 'الصيغة المطلوبة: MM/YY',
  'billing.pay.expires': 'ينتهي في {date}',
  'billing.pay.default': 'الافتراضية',
  'billing.pay.makeDefault': 'جعل {name} افتراضية',
  'billing.pay.remove': 'حذف {name}',
  'billing.pay.removeTitle': 'حذف وسيلة الدفع هذه؟',
  'billing.pay.removeDesc': 'سيُلغى الرمز لدى المزوّد.',
  'billing.pay.removeConfirm': 'حذف',
  'billing.pay.removed': 'تم حذف وسيلة الدفع',
  'billing.pay.removeError': 'تعذّر الحذف',
  'billing.pay.removeDefault': 'عيّن وسيلة افتراضية أخرى أولًا',
  'billing.pay.error': 'تعذّرت العملية',
  'billing.pay.empty': 'لا توجد وسيلة دفع',
  'billing.pay.emptyDesc': 'أضف بطاقة CIB أو بطاقة دولية.',
  'billing.pay.tokenNote': 'لا يخزّن سراج أرقام البطاقات: يُحتفظ فقط برمز والعلامة وآخر 4 أرقام وتاريخ الانتهاء.',
  'billing.credits.buy': 'شراء رصيد الذكاء الاصطناعي',
  'billing.credits.title': 'شراء رصيد الذكاء الاصطناعي',
  'billing.credits.desc': 'يُضاف الرصيد إلى حصتك فورًا.',
  'billing.credits.pack': '{count} رصيد',
  'billing.credits.confirm': 'ادفع {amount}',
  'billing.credits.done': 'تمت إضافة {count} رصيد',
  'billing.credits.error': 'تعذّر الشراء',
  'billing.credits.needMethod': 'يلزم وجود وسيلة دفع لشراء الرصيد.',
  'billing.credits.addMethod': 'إضافة وسيلة دفع',
};
